import styled from 'styled-components';

// Styled component for the text
export const TextWrapper = styled.span<{ width: number }>`
  border-right: 3px solid black;
  display: inline-block;
  white-space: nowrap;
  animation:
    typing 2s steps(20) 1s forwards,
    blink 0.75s step-end infinite @keyframes typing {
    from {
      width: 0;
    }
    to {
      width: ${({ width }) => width}px;
    }
  }

  @keyframes blink {
    50% {
      border-color: transparent;
    }
  }
`;
